/**
 * Helper utilities for Delivery Service invoice routes and navigation
 */

/**
 * Builds the invoice route URL with optional query parameters
 * @param invoiceNumber - The invoice number
 * @param mode - The view mode ('view' or 'edit')
 * @param workOrderId - Optional work order ID for back-navigation context
 * @returns The constructed route URL
 */
export const buildInvoiceRoute = (
  invoiceNumber: string,
  mode: 'view' | 'edit' = 'view',
  workOrderId?: string | null | undefined
): string => {
  const basePath = `/delivery/invoice/${invoiceNumber}`;
  const modePath = mode === 'edit' ? `${basePath}/edit` : basePath;
  const queryParam = workOrderId ? `?workOrderId=${workOrderId}` : '';
  return `${modePath}${queryParam}`;
};
